'use client';

import { useState } from 'react';

import { canEditAppointmentByTime } from './_utils/can-edit-appointment';

import { Appointment } from '@/types/appointments.types';
import { ProgressiveModal } from '@/components/ui/progressive-modal/progressive-modal.component';
import { AppointmentOptionsModalKeys } from '@/app/(main)/(pages)/(auth)/agendamentos/_components/card-appointment/variants/_components/appointment-options/appointment-options-button.component';
import SelectPatientList from '@/app/(main)/(pages)/(auth)/agendamentos/_components/card-appointment/variants/_components/appointment-options/_components/select-patient/select-patient-list.component';
import { SelectPatientCreate } from '@/app/(main)/(pages)/(auth)/agendamentos/_components/card-appointment/variants/_components/appointment-options/_components/select-patient/select-patient-create.component';
import { AppointmentRescheduleSlotsModal } from '@/app/(main)/(pages)/(auth)/agendamentos/_components/card-appointment/variants/_components/appointment-options/_components/reschedule-slots-modal/appointment-reschedule-slots-modal.component';

interface AppointmentCardActionsProps {
  appointment: Appointment;
  onAppointmentUpdate?: (appointment: Partial<Appointment>) => void;
  children: (actions: {
    onEditDate?: () => void;
    onEditPatient?: () => void;
  }) => React.ReactNode;
}

export function AppointmentCardActions({ appointment, onAppointmentUpdate, children }: AppointmentCardActionsProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [initialModalKey, setInitialModalKey] = useState<AppointmentOptionsModalKeys>(
    AppointmentOptionsModalKeys.CHANGE_DATE,
  );

  const onEditDate = () => {
    setInitialModalKey(AppointmentOptionsModalKeys.CHANGE_DATE);
    setIsOpen(true);
  };

  const onEditPatient = () => {
    setInitialModalKey(AppointmentOptionsModalKeys.CHANGE_PATIENT_LIST);
    setIsOpen(true);
  };

  const canEdit = canEditAppointmentByTime(appointment.start);

  return (
    <>
      {children({
        onEditDate: canEdit ? onEditDate : undefined,
        onEditPatient: canEdit ? onEditPatient : undefined,
      })}
      <ProgressiveModal
        sheetSide="centerFit"
        sheetSideByKey={{
          [AppointmentOptionsModalKeys.CHANGE_DATE]: 'centerWide',
          [AppointmentOptionsModalKeys.CHANGE_PATIENT_LIST]: 'center-v2',
          [AppointmentOptionsModalKeys.CHANGE_PATIENT_CREATE]: 'center-v2',
        }}
        initialKey={initialModalKey}
        open={isOpen}
        handleClose={() => setIsOpen(false)}
      >
        <SelectPatientList
          key={AppointmentOptionsModalKeys.CHANGE_PATIENT_LIST}
          appointment={appointment}
        />
        <SelectPatientCreate key={AppointmentOptionsModalKeys.CHANGE_PATIENT_CREATE} />
        <AppointmentRescheduleSlotsModal
          key={AppointmentOptionsModalKeys.CHANGE_DATE}
          appointment={appointment}
          onAppointmentUpdate={onAppointmentUpdate}
        />
      </ProgressiveModal>
    </>
  );
}
